export interface RhSection {
  spec: string;
  areaCm2: number;
  unitWeightKgM: number;
}

export const rhSections: RhSection[] = [
  { spec: "100X50X5X7", areaCm2: 11.85, unitWeightKgM: 9.3 },
  { spec: "100X100X6X8", areaCm2: 21.59, unitWeightKgM: 16.9 },
  { spec: "125X60X6X8", areaCm2: 16.69, unitWeightKgM: 13.1 },
  { spec: "125X125X6.5X9", areaCm2: 30, unitWeightKgM: 23.6 },
  { spec: "150X75X5X7", areaCm2: 17.85, unitWeightKgM: 14 },
  { spec: "148X100X6X9", areaCm2: 26.35, unitWeightKgM: 20.7 },
  { spec: "150X150X7X10", areaCm2: 39.65, unitWeightKgM: 31.1 },
  { spec: "175X90X5X8", areaCm2: 22.9, unitWeightKgM: 18 },
  { spec: "169X125X5.5X8", areaCm2: 29.65, unitWeightKgM: 23.3 },
  { spec: "175X175X7.5X11", areaCm2: 51.43, unitWeightKgM: 40.4 },
  { spec: "198X99X4.5X7", areaCm2: 22.69, unitWeightKgM: 17.8 },
  { spec: "200X100X5.5X8", areaCm2: 26.67, unitWeightKgM: 20.9 },
  { spec: "194X150X6X9", areaCm2: 38.11, unitWeightKgM: 29.9 },
  { spec: "200X200X8X12", areaCm2: 63.53, unitWeightKgM: 49.9 },
  { spec: "200X204X12X12", areaCm2: 71.53, unitWeightKgM: 56.2 },
  { spec: "208X202X10X16", areaCm2: 83.69, unitWeightKgM: 65.7 },
  { spec: "248X124X5X8", areaCm2: 31.99, unitWeightKgM: 25.1 },
  { spec: "250X125X6X9", areaCm2: 36.97, unitWeightKgM: 29 },
  { spec: "244X175X7X11", areaCm2: 55.49, unitWeightKgM: 43.6 },
  { spec: "248X249X8X13", areaCm2: 83.95, unitWeightKgM: 65.9 },
  { spec: "250X250X9X14", areaCm2: 91.43, unitWeightKgM: 71.8 },
  { spec: "244X252X11X11", areaCm2: 81.31, unitWeightKgM: 63.8 },
  { spec: "250X255X14X14", areaCm2: 103.9, unitWeightKgM: 81.6 },
  { spec: "298X149X5.5X8", areaCm2: 40.8, unitWeightKgM: 32 },
  { spec: "300X150X6.5X9", areaCm2: 46.78, unitWeightKgM: 36.7 },
  { spec: "294X200X8X12", areaCm2: 71.05, unitWeightKgM: 55.8 },
  { spec: "298X201X9X14", areaCm2: 82.03, unitWeightKgM: 64.4 },
  { spec: "294X302X12X12", areaCm2: 106.3, unitWeightKgM: 83.4 },
  { spec: "300X300X10X15", areaCm2: 118.5, unitWeightKgM: 93 },
  { spec: "300X305X15X15", areaCm2: 133.4, unitWeightKgM: 105 },
  { spec: "304X301X11X17", areaCm2: 133.5, unitWeightKgM: 105 },
  { spec: "312X303X13X21", areaCm2: 163.8, unitWeightKgM: 129 },
  { spec: "318X307X17X24", areaCm2: 194.7, unitWeightKgM: 153 },
  { spec: "326X310X20X28", areaCm2: 229.1, unitWeightKgM: 180 },
  { spec: "346X174X6X9", areaCm2: 52.45, unitWeightKgM: 41.2 },
  { spec: "350X175X7X11", areaCm2: 62.91, unitWeightKgM: 49.4 },
  { spec: "336X249X8X12", areaCm2: 86.17, unitWeightKgM: 67.6 },
  { spec: "340X250X9X14", areaCm2: 99.53, unitWeightKgM: 78.1 },
  { spec: "350X252X11X19", areaCm2: 131.5, unitWeightKgM: 103 },
  { spec: "356X256X15X22", areaCm2: 160.9, unitWeightKgM: 126 },
  { spec: "364X258X17X26", areaCm2: 188.7, unitWeightKgM: 148 },
  { spec: "338X351X13X13", areaCm2: 133.3, unitWeightKgM: 105 },
  { spec: "344X348X10X16", areaCm2: 144, unitWeightKgM: 113 },
  { spec: "344X354X16X16", areaCm2: 164.7, unitWeightKgM: 129 },
  { spec: "350X350X12X19", areaCm2: 171.9, unitWeightKgM: 135 },
  { spec: "352X350X12X20", areaCm2: 178.9, unitWeightKgM: 140 },
  { spec: "350X357X19X19", areaCm2: 196.4, unitWeightKgM: 154 },
  { spec: "356X352X14X22", areaCm2: 200, unitWeightKgM: 157 },
  { spec: "360X354X16X24", areaCm2: 221.3, unitWeightKgM: 174 },
  { spec: "368X356X18X28", areaCm2: 257, unitWeightKgM: 202 },
  { spec: "378X358X20X33", areaCm2: 300.1, unitWeightKgM: 236 },
  { spec: "396X199X7X11", areaCm2: 71.41, unitWeightKgM: 56.1 },
  { spec: "400X200X8X13", areaCm2: 83.37, unitWeightKgM: 65.4 },
  { spec: "386X299X9X14", areaCm2: 117.4, unitWeightKgM: 92.2 },
  { spec: "390X300X10X16", areaCm2: 133.3, unitWeightKgM: 105 },
  { spec: "400X304X14X21", areaCm2: 179.3, unitWeightKgM: 141 },
  { spec: "410X308X18X26", areaCm2: 226.1, unitWeightKgM: 177 },
  { spec: "418X310X20X30", areaCm2: 259.1, unitWeightKgM: 203 },
  { spec: "388X402X15X15", areaCm2: 178.5, unitWeightKgM: 140 },
  { spec: "394X398X11X18", areaCm2: 186.8, unitWeightKgM: 147 },
  { spec: "394X405X18X18", areaCm2: 214.4, unitWeightKgM: 168 },
  { spec: "400X400X13X21", areaCm2: 218.7, unitWeightKgM: 172 },
  { spec: "400X408X21X21", areaCm2: 250.7, unitWeightKgM: 197 },
  { spec: "406X403X16X24", areaCm2: 254.9, unitWeightKgM: 200 },
  { spec: "414X405X18X28", areaCm2: 295.4, unitWeightKgM: 232 },
  { spec: "428X407X20X35", areaCm2: 360.7, unitWeightKgM: 283 },
  { spec: "458X417X30X50", areaCm2: 528.6, unitWeightKgM: 415 },
  { spec: "498X432X45X70", areaCm2: 770.1, unitWeightKgM: 605 },
  { spec: "446X199X8X12", areaCm2: 82.97, unitWeightKgM: 65.1 },
  { spec: "450X200X9X14", areaCm2: 95.43, unitWeightKgM: 74.9 },
  { spec: "456X201X10X17", areaCm2: 112, unitWeightKgM: 87.9 },
  { spec: "466X205X14X22", areaCm2: 150.7, unitWeightKgM: 118 },
  { spec: "478X208X17X28", areaCm2: 189.7, unitWeightKgM: 149 },
  { spec: "434X299X10X15", areaCm2: 131.6, unitWeightKgM: 103 },
  { spec: "440X300X11X18", areaCm2: 153.9, unitWeightKgM: 121 },
  { spec: "446X302X13X21", areaCm2: 180.8, unitWeightKgM: 142 },
  { spec: "450X304X15X23", areaCm2: 201.9, unitWeightKgM: 158 },
  { spec: "458X306X17X27", areaCm2: 235.4, unitWeightKgM: 185 },
  { spec: "468X308X19X32", areaCm2: 275.3, unitWeightKgM: 216 },
  { spec: "496X199X9X14", areaCm2: 99.29, unitWeightKgM: 77.9 },
  { spec: "500X200X10X16", areaCm2: 112.3, unitWeightKgM: 88.2 },
  { spec: "506X201X11X19", areaCm2: 129.3, unitWeightKgM: 102 },
  { spec: "512X202X12X22", areaCm2: 146.5, unitWeightKgM: 115 },
  { spec: "518X205X15X25", areaCm2: 174.2, unitWeightKgM: 137 },
  { spec: "528X208X18X30", areaCm2: 210.5, unitWeightKgM: 165 },
  { spec: "536X210X20X34", areaCm2: 237.9, unitWeightKgM: 187 },
  { spec: "548X215X25X40", areaCm2: 290.5, unitWeightKgM: 228 },
  { spec: "482X300X11X15", areaCm2: 141.2, unitWeightKgM: 111 },
  { spec: "488X300X11X18", areaCm2: 159.2, unitWeightKgM: 125 },
  { spec: "494X302X13X21", areaCm2: 187.1, unitWeightKgM: 147 },
  { spec: "500X304X15X24", areaCm2: 215.2, unitWeightKgM: 169 },
  { spec: "510X306X17X29", areaCm2: 255.8, unitWeightKgM: 201 },
  { spec: "518X310X21X33", areaCm2: 301, unitWeightKgM: 236 },
  { spec: "532X314X25X40", areaCm2: 365.7, unitWeightKgM: 287 },
  { spec: "500X500X25X25", areaCm2: 368.3, unitWeightKgM: 289 },
  { spec: "546X199X10X14", areaCm2: 109, unitWeightKgM: 85.5 },
  { spec: "550X200X10X18", areaCm2: 124.8, unitWeightKgM: 98 },
  { spec: "554X201X11X18", areaCm2: 133.5, unitWeightKgM: 105 },
  { spec: "560X202X12X21", areaCm2: 151.2, unitWeightKgM: 119 },
  { spec: "564X203X13X23", areaCm2: 162.2, unitWeightKgM: 127 },
  { spec: "596X199X10X15", areaCm2: 117.8, unitWeightKgM: 92.5 },
  { spec: "600X200X11X17", areaCm2: 131.7, unitWeightKgM: 103 },
  { spec: "606X201X12X20", areaCm2: 149.9, unitWeightKgM: 118 },
  { spec: "612X202X13X23", areaCm2: 168, unitWeightKgM: 132 },
  { spec: "618X205X16X26", areaCm2: 198.6, unitWeightKgM: 156 },
  { spec: "626X207X18X30", areaCm2: 227.5, unitWeightKgM: 179 },
  { spec: "634X209X20X34", areaCm2: 256.8, unitWeightKgM: 202 },
  { spec: "646X214X25X40", areaCm2: 314.2, unitWeightKgM: 247 },
  { spec: "582X300X12X17", areaCm2: 169.2, unitWeightKgM: 133 },
  { spec: "588X300X12X20", areaCm2: 187.2, unitWeightKgM: 147 },
  { spec: "594X302X14X23", areaCm2: 217.1, unitWeightKgM: 170 },
  { spec: "600X304X16X26", areaCm2: 247.2, unitWeightKgM: 194 },
  { spec: "608X306X18X30", areaCm2: 283.7, unitWeightKgM: 223 },
  { spec: "616X308X20X34", areaCm2: 320.5, unitWeightKgM: 252 },
  { spec: "628X312X24X40", areaCm2: 382.6, unitWeightKgM: 300 },
  { spec: "692X300X13X20", areaCm2: 207.5, unitWeightKgM: 163 },
  { spec: "700X300X13X24", areaCm2: 231.5, unitWeightKgM: 182 },
  { spec: "708X302X15X28", areaCm2: 269.7, unitWeightKgM: 212 },
  { spec: "712X306X19X30", areaCm2: 310.3, unitWeightKgM: 244 },
  { spec: "718X308X21X33", areaCm2: 343, unitWeightKgM: 269 },
  { spec: "732X311X24X40", areaCm2: 408.1, unitWeightKgM: 320 },
  { spec: "792X300X14X22", areaCm2: 239.5, unitWeightKgM: 188 },
  { spec: "800X300X14X26", areaCm2: 263.5, unitWeightKgM: 207 },
  { spec: "808X302X16X30", areaCm2: 303.7, unitWeightKgM: 238 },
  { spec: "816X306X20X34", areaCm2: 360.5, unitWeightKgM: 283 },
  { spec: "828X308X22X40", areaCm2: 413.7, unitWeightKgM: 325 },
  { spec: "890X299X15X23", areaCm2: 266.9, unitWeightKgM: 210 },
  { spec: "900X300X16X28", areaCm2: 305.8, unitWeightKgM: 240 },
  { spec: "912X302X18X34", areaCm2: 360.1, unitWeightKgM: 283 },
  { spec: "918X303X19X37", areaCm2: 387.4, unitWeightKgM: 304 },
];

export const rhSpecs: string[] = rhSections.map((section) => section.spec);

export function normalizeSteelSpec(spec: string): string {
  return spec
    .toUpperCase()
    .replace(/[＊*×]/g, "X")
    .split("X")
    .map((part) => {
      const num = Number(part.trim());
      return Number.isFinite(num) ? String(num) : part.trim();
    })
    .join("X");
}

const rhSectionsBySpec = new Map(
  rhSections.map((section) => [normalizeSteelSpec(section.spec), section]),
);

export function lookupRhSection(spec: string): RhSection | null {
  if (!spec) return null;
  return rhSectionsBySpec.get(normalizeSteelSpec(spec)) ?? null;
}
